import useTranslator from "../../hooks/useTranslator";
import {
  convertCurrencyFormat,
  getUpdatedExchangeIncome,
} from "../../helper/common";
import IncomePanel, { IncomePanelOption } from "./IncomePanel";

/**
 * Other income side panel: one level, each entry is a checkbox
 * (amount is monthly).
 */
const OtherIncomeSelectionModal = ({
  isOpen,
  onClose,
  items = [],
  selectedIds = [],
  onToggle,
  total = 0,
  originalUser,
}) => {
  const { _t } = useTranslator();

  if (!isOpen) return null;

  const selected = new Set(selectedIds);

  return (
    <IncomePanel
      isOpen={isOpen}
      onClose={onClose}
      title={_t("otherIncomes")}
      crumbs={[
        { label: _t("income"), onClick: onClose },
        { label: _t("otherIncomes") },
      ]}
      total={total}
    >
      <div className="incomePanel__list">
        {items.map((item) => (
          <IncomePanelOption
            key={item.id}
            isOn={selected.has(item.id)}
            label={item?.name ?? _t("otherIncomes")}
            sub={item?.date ?? null}
            value={`€${convertCurrencyFormat(
              getUpdatedExchangeIncome(
                item?.amount ?? 0,
                item?.currency,
                originalUser
              ) || 0
            )}/${_t("mo")}${
              item?.currency && item.currency !== "EUR"
                ? ` (${_t("converted")})`
                : ""
            }`}
            onToggle={() => onToggle(item.id)}
          />
        ))}
      </div>
    </IncomePanel>
  );
};

export default OtherIncomeSelectionModal;
